import { defineStore } from 'pinia';
import axiosInstance from '@/axios';
import urlList from '../../utils/apis.json';

export const useAuthStore = defineStore('auth', {
    state: () => ({
        token: localStorage.getItem('token') || null,
    }),

    actions: {
        async login(payload = null) {
            try {
                const response = await axiosInstance.post(urlList['userLogin'], { ...payload },{ noAuth: true });
                this.token = response.data.accessToken;
                localStorage.setItem('token', this.token);
                return response;
            } catch (error) {
                throw error;
            }
        },

        logout() {
            try {
                const res = axiosInstance.post(urlList['userLogout']);
                this.token = null;
                localStorage.removeItem('token');
                return res;
            } catch (error) {
                throw error;
            }
        },
    },
    getters: {},
});
